import * as React from "react";
import { IdStatValueType } from "../../constants/IdStatValueType";
import { IdStyles } from "../../less/IdStyles";
import { utilTime } from "../../utils/utilTime";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var StoreItemStats = function (_a) {
    var item = _a.item;
    var shownStat = item.balancing.shownStat;
    if (shownStat == undefined) {
        // tslint:disable-next-line:no-null-keyword
        return null;
    }
    var stats = shownStat.map(function (stat, index) {
        var statAmount = React.createElement(NumberFormat, { amount: stat.bonusValue, format: TypeNumberFormat.Add });
        if (stat.valueType && stat.valueType === IdStatValueType.Percentage) {
            var percentage = stat.bonusValue * 100;
            statAmount = (React.createElement(NumberFormat, { amount: percentage, format: TypeNumberFormat.SignedPercent }));
        }
        if (stat.valueType && stat.valueType === IdStatValueType.Time) {
            statAmount = React.createElement("span", null, utilTime.format(stat.bonusValue));
        }
        return (React.createElement("div", { className: "store-item-stats__item", key: index },
            React.createElement(Icon, { icon: stat.icon, styleId: IdStyles.IconMedium }),
            React.createElement("div", { className: IdStyles.TextBoldAccent }, statAmount)));
    });
    return React.createElement("div", { className: "store-item-stats" }, stats);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/StoreItemStats.tsx
// module id = 2761
// module chunks = 3